import axios from "axios";

class BannerService {
  static getBanners = (siteId) =>
    axios.get("/getBanners", { params: { siteId } }).then((response) => {
      return response.data?.data || [];
    });
}

export default BannerService;
